module.exports = ".chatmessage{display:block;color:#e2e2e2 !important;clear:both;cursor:pointer;padding:2px 3px;position:relative}.chatmessage::after{content:'';display:block;width:100%;margin-top:10px;border-bottom:1px solid #404040}.chatmessage .content{overflow-wrap:break-word}.chatmessage .content .author{font-size:10px;padding-right:5px;color:#9e9e9e}.chatmessage .content .msg{font-size:12px;text-align:left !important}.chatmessage .content .timestamp{font-size:9px;color:#4e4e4e}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/chat/chat-message/chat-message.component.scss
// module id = 1043
// module chunks = 0